import React from 'react';
import { useMemo, useState } from 'react';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import * as columns from '../../misc/Columns';
import { Dialog, Button, DialogActions } from '@mui/material';
import { NewOrEdit } from '../NewOrEdit.tsx';
import { useDependencies } from '../../misc/DependenciesProvider.tsx';
import * as dataManCommon from './DataManCommon.ts';

interface VocabAddNewProps {
    columns: columns.ColumnInfo[];
    tabName: string;
    db_name_of_vocab: string;
    onHandleClose: () => void;
}

interface NewDataType {
    [key: string]: string;
}

export function VocabAddNew({
    columns,
    tabName,
    db_name_of_vocab,
    onHandleClose
}: VocabAddNewProps): JSX.Element {

    const { showMessage } = useSnackbarMessage();
    const { fracAPI } = useDependencies();
    const [isAdding, setIsAdding] = useState<boolean>(false);

    const columnsForNew: columns.ColumnInfo[] = useMemo(() => {
        return getColumns(columns);
    }, [columns]);

    const [newData, setNewData] = useState<NewDataType>(() => {
        const record: NewDataType = {};
        const cols = getColumns(columns);
        cols.forEach((col) => {
            record[col.id] = '';
        });
        return record;
    });


    const handleAdd = async () => {
        try {
            setIsAdding(true);
            const data = dataManCommon.convertEditDataAsNew(db_name_of_vocab, newData, columns);
            await fracAPI.createVocabularyRecord(data);
            onHandleClose();

        } catch (error: any) {
            console.error("Error updating record: " + error);
            showMessage("Error updating record. Please try again.");

        } finally {
            setIsAdding(false);
        }
    }


    return (
        <div>
            <Dialog
                id="add-new-dialog"
                onClose={onHandleClose}
                open={true}
                fullWidth={true}
                maxWidth="lg"
            >
                <NewOrEdit
                    rowData={newData}
                    columns={columnsForNew}
                    changedData={(data: NewDataType) => setNewData(data)}
                    lovs={{}}
                />
                <DialogActions>
                    <Button onClick={onHandleClose}>Close</Button>
                    <Button
                        id="add-item-button"
                        onClick={handleAdd}
                        disabled={isAdding}
                        autoFocus
                    >
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}


function getColumns(columns: columns.ColumnInfo[]): columns.ColumnInfo[] {
    const newColsWithIdHidden: columns.ColumnInfo[] = columns.map((col) => {
        const newCol: columns.ColumnInfo = { ...col };
        if (newCol.id === 'id') {
            newCol.hidden = true;
        }
        return newCol;
    });

    const newColsFiltered: columns.ColumnInfo[] = newColsWithIdHidden.filter((col) => {
        if (col.type !== 'action') {
            return col;
        }
        return false;
    }) as columns.ColumnInfo[];

    return newColsFiltered;
}